import src from "IMAGE";
export default { src, width: 1033, height: 902, blurWidth: 0, blurHeight: 0};
